<template lang="pug" src="./slider-our-smiles.pug"></template>

<script>
import SliderTestimonialsDirective from './slider-our-smiles.directive'
export default {
  props: ['props'],
  directives: {
    SliderTestimonialsDirective
  }
}
</script>



// WEBPACK FOOTER //
// slider-our-smiles.vue?6c9c49d7